// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"43":"test","177":"home","343":"onboarding","757":"game"}[chunkId] || chunkId) + "." + {"43":"876cef7a","177":"43cdf0cf","336":"1e6f7101","343":"66c7602b","455":"3a82af9a","757":"402e84a3"}[chunkId] + ".js";
};